var map = {
	"./childrensDay-land-page.png": 766,
	"./likes-img.png": 764,
	"./likes-imgx.png": 2453,
	"./mask-close.png": 653,
	"./mask-close1.png": 2454,
	"./share-get-zan.png": 659,
	"./share-invite.png": 658,
	"./shop1.png": 767,
	"./shop2.png": 768,
	"./tab0.png": 2455,
	"./tab1.png": 2456,
	"./tab2.png": 2457,
	"./zan-now.png": 765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2452;